export default "__VITE_ASSET__DVwtLjp5__"